import "./UpdateUsersById.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import useRegions from "../../hooks/useRegions";
import FormInput from "../../components/FormInput/FormInput";
import newRequest from "../../context/newRequest";
import { sleep } from "../../helper/helper";

const UpdateUsersById = ({ title }) => {
  const [values, setValues] = useState({
    username: "",
    email: "",
    company_name: "",
    password: "",
    confirmPassword: "",
  });
  const { userId } = useParams();
  const user = localStorage.getItem("user");
  const [regionId, setRegionId] = useState("");
  const [roleId, setRoleId] = useState(2);
  const { regions } = useRegions();
  const { data, loading } = useFetch(`/users/${userId}`);
  const [sending, setSending] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      setValues((prev) => ({
        ...prev,
        username: data.username || "",
        email: data.email || "",
        company_name: data.company_name || "",
      }));
      if (data.region_id) {
        setRegionId(data.region_id);
      }
      if (data.role_id) {
        setRoleId(data.role_id);
      }
    }
  }, [data]);

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSelectRegionID = (e) => {
    setRegionId(e.target.value);
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      setSending("On Submit");
      const newUsersUpdate = {
        username: values.username,
        email: values.email,
        company_name: values.company_name,
        region_id: regionId,
        role_id: Number(roleId),
      };

      if (values.password) {
        newUsersUpdate.password = values.password;
      }

      await sleep(500);
      setSending("Mengirim data ...");

      const res = await newRequest.put(`/users/${userId}`, newUsersUpdate, {
        headers: user && user.token ? { Authorization: `Bearer ${user.token}` } : {},
      });

      setSending("Sending...");
      if (res.status === 200) {
        setSending("Berhasil mengupdate user!");
        await sleep(800);
        navigate(`/users/${userId}`);
      }
    } catch (err) {
      const errMsg =
        (err.response && err.response.data && err.response.data.errors) ||
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        "Gagal update user";
      setSending(errMsg);
      console.log(err);
    }
  };

  const inputs = [
    {
      id: "username",
      name: "username",
      type: "text",
      placeholder: "username",
      errorMessage:
        "Username should be 3-16 characters and shouldn't include any special character!",
      label: "Username",
      pattern: "^[A-Za-z0-9]{3,16}$",
      required: false,
    },
    {
      id: "email",
      name: "email",
      type: "email",
      placeholder: "email",
      errorMessage: "It should be a valid email address!",
      label: "Email",
      required: false,
    },
    {
      id: "company_name",
      name: "company_name",
      type: "text",
      placeholder: "company name",
      errorMessage:
        "Company should be 3-16 characters and shouldn't include any special character!",
      label: "Company Name",
      required: false,
    },
    {
      id: "password",
      name: "password",
      type: "password",
      placeholder: "Password baru (opsional)",
      errorMessage:
        "Password should be 8-20 characters and include at least 1 uppercase letter, 2 numbers, and any other characters!",
      label: "Password Baru (kosongkan jika tidak ingin mengubah)",
      required: false,
    },
    {
      id: "confirm_password",
      name: "confirmPassword",
      type: "password",
      placeholder: "Confirm Password",
      errorMessage: "Passwords don't match!",
      label: "Konfirmasi Password Baru",
      pattern: values.password,
      required: false,
    },
  ];

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <div className="detailItem">
              <div>
                <h1>User ID: {userId}</h1>
                {loading && <p>Memuat data user...</p>}
              </div>
            </div>
            <form onSubmit={handleClick}>
              {inputs.map((input) => (
                <FormInput
                  key={input.id}
                  {...input}
                  value={values[input.name]}
                  onChange={handleChange}
                />
              ))}

              <div style={{ width: "100%", margin: "10px 0" }}>
                <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold", fontSize: "14px", color: "#334155" }}>
                  Role Pengguna:
                </label>
                <select
                  id="role_id"
                  value={roleId}
                  onChange={(e) => setRoleId(Number(e.target.value))}
                  style={{
                    width: "100%",
                    padding: "8px 10px",
                    borderRadius: "4px",
                    border: "1px solid #cbd5e1",
                    backgroundColor: roleId === 1 ? "#ecfdf5" : "#fff",
                    fontWeight: roleId === 1 ? "bold" : "normal",
                    color: roleId === 1 ? "#065f46" : "#333",
                  }}
                >
                  <option value={2}>Customer / User Biasa (Role: 2)</option>
                  <option value={1}>Admin (Role: 1 - Akses Penuh)</option>
                  <option value={99}>Superadmin (Role: 99)</option>
                  <option value={18}>Readuser (Role: 18)</option>
                  <option value={50}>Nonaktif (Role: 50)</option>
                </select>
                {roleId !== 1 && (
                  <button
                    type="button"
                    onClick={() => setRoleId(1)}
                    style={{
                      marginTop: "6px",
                      padding: "4px 10px",
                      fontSize: "12px",
                      backgroundColor: "#0284c7",
                      color: "#fff",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Set Jadi Admin
                  </button>
                )}
              </div>

              <div style={{ width: "100%", margin: "10px 0" }}>
                <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold", fontSize: "14px", color: "#334155" }}>
                  Region:
                </label>
                <select
                  id="region_id"
                  value={regionId}
                  onChange={handleSelectRegionID}
                  style={{
                    width: "100%",
                    padding: "8px 10px",
                    borderRadius: "4px",
                    border: "1px solid #cbd5e1",
                  }}
                >
                  <option value="">Pilih Region Id</option>
                  {regions.map((reg) => (
                    <option key={reg.id} value={reg.id}>
                      {reg.id} {reg.description ? `(${reg.description})` : ""}
                    </option>
                  ))}
                </select>
              </div>

              <button type="submit">Submit</button>
            </form>
          </div>
          {sending && <p className="error">{sending}</p>}
        </div>
      </div>
    </div>
  );
};

export default UpdateUsersById;
